import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useFilterStore } from "@faire/retailer/components/Filters/useFilterStore";
import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
export var useFilterScrollToProducts = function(scrollRef, isPageReady, shouldEnableScroll) {
    var _useFilterStore = useFilterStore([
        "isNewFilterSelected",
        "shouldScrollToResults"
    ]), _useFilterStore_data = _useFilterStore.data, isNewFilterSelected = _useFilterStore_data.isNewFilterSelected, shouldScrollToResults = _useFilterStore_data.shouldScrollToResults;
    var currentPath = getCurrentPath();
    var replace = useHistory().replace;
    var headerPlusPromoBannerHeight = useTopOfPageContent().headerPlusPromoBannerHeight;
    var scrollToTop = useCallback(function() {
        var _scrollRef_current, _getWindowOrThrow_scrollTo, _getWindowOrThrow;
        if (currentPath.searchParams.get("scrollToResults")) {
            replace(currentPath.delete("scrollToResults").toString());
        }
        var offsetTop = 0;
        var marginTop = 16;
        if (scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.offsetTop) {
            offsetTop = scrollRef.current.offsetTop - headerPlusPromoBannerHeight - marginTop;
        }
        (_getWindowOrThrow_scrollTo = (_getWindowOrThrow = getWindowOrThrow()).scrollTo) === null || _getWindowOrThrow_scrollTo === void 0 ? void 0 : _getWindowOrThrow_scrollTo.call(_getWindowOrThrow, {
            top: offsetTop,
            behavior: "smooth"
        });
    }, [
        headerPlusPromoBannerHeight,
        scrollRef,
        currentPath,
        replace
    ]);
    useEffect(function() {
        var _scrollRef_current, _scrollRef_current1;
        if (!shouldEnableScroll) {
            return;
        }
        var isScrollableHeight = (scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.offsetTop) && (scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef_current1 = scrollRef.current) === null || _scrollRef_current1 === void 0 ? void 0 : _scrollRef_current1.offsetTop) > 200;
        if (isNewFilterSelected && shouldScrollToResults) {
            scrollToTop();
        } else if (currentPath.searchParams.get("scrollToResults") && isPageReady && isScrollableHeight) {
            scrollToTop();
        }
    }, [
        scrollToTop,
        isNewFilterSelected,
        shouldScrollToResults,
        currentPath,
        replace,
        isPageReady,
        scrollRef,
        shouldEnableScroll
    ]);
};
